export const FETCH_TAGS_REQUEST = '@@tags/FETCH_TAGS_REQUEST';
export const FETCH_TAGS_SUCCESS = '@@tags/FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAILURE = '@@tags/FETCH_TAGS_FAILURE';
export const ADD_TAG = '@@tags/ADD_TAG';

export const FETCH_TAGS_ERROR = '@@tags/FETCH_TAGS_ERROR';


// WEBPACK FOOTER //
// ./src/constants/tags.js